import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn', 'updateCompanyInfo']),
}

export const appAuthMethods = mapActions(
  'appAuth', ['appLogIn', 'companyInfoExists'])


export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions(
  'auth', ['logIn', 'logOut', 'register',
  'resetPassword', 'setUserActiveSection', 'logInTwoFactor', 'forgotPasswordAction',
  'resetPasswordAction'])

export const twoFactorAuthMethods = mapActions(
  'twoFactorAuth', ['sendEmailAuth', 'fetchQR', 'activateTotpAuth',
  'activateEmailAuth', 'fetchAuthDevices', 'deleteTotpAuth', 'deleteEmailAuth'])

export const languageComputed = {
  ...mapState('language', {
    language: (state) => state.language,
  })
}

export const languageMethods = mapActions(
  'language', ['setLanguage'])

export const usersComputed = {
  ...mapState('management/users', {
    cached: (state) => state.cached,
  }),
}

export const usersMethods = mapActions(
  'management/users', [
  'fetchUsers', 'createUpdateUsers',
  'deleteUsers', 'changePassword',
  'updatePhotos', 'fetchUsersDetail',
  'fetchUsersForOptions', 'checkIfUserExists',
  'registerUsers', 'changeFirstLoginAction']
)

export const permsComputed = {
  ...mapState('management/perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions(
  'management/perms', ['fetchPerms', 'createUpdatePerms',
  'deletePerms', 'fetchPermsDetail'])


export const groupsComputed = {
  ...mapState('management/groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions(
  'management/groups', ['fetchGroups', 'createUpdateGroups',
  'deleteGroups', 'fetchGroupsDetail'])

export const appSectionsComputed = {
  ...mapState('management/appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions(
  'management/appSections', ['fetchAppSections', 'createUpdateAppSections',
  'deleteAppSections', 'fetchAppSectionsDetail'])



export const companyInfoComputed = {
  ...mapState('management/companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions(
  'management/companyInfo', ['fetchCompanyInfo', 'createUpdateCompanyInfo', 'setFileCompanyInfo'])

// Periodic tasks helpers
export const periodicTasksMethods = mapActions(
  'management/periodicTasks/periodicTasks', ['fetchPeriodicTasks', 'createUpdatePeriodicTasks',
  'deletePeriodicTasks', 'fetchPeriodicTasksDetail', 'fetchPeriodicTasksOptions',
  'getLiveResultsPeriodicTasks', 'executeManuallyPeriodicTasks'])

export const periodicTasksResultsMethods = mapActions(
  'management/periodicTasks/periodicTasksResults', ['fetchPeriodicTasksResults', 'createUpdatePeriodicTasksResults',
  'deletePeriodicTasksResults', 'fetchPeriodicTasksResultsDetail'])

export const periodicTasksSolarScheduleMethods = mapActions(
  'management/periodicTasks/periodicTasksSolarSchedule', ['fetchPeriodicTasksSolarSchedule', 'createUpdatePeriodicTasksSolarSchedule',
  'deletePeriodicTasksSolarSchedule', 'fetchPeriodicTasksSolarScheduleDetail'])

export const periodicTasksIntervalScheduleMethods = mapActions(
  'management/periodicTasks/periodicTasksIntervalSchedule', ['fetchPeriodicTasksIntervalSchedule', 'createUpdatePeriodicTasksIntervalSchedule',
  'deletePeriodicTasksIntervalSchedule', 'fetchPeriodicTasksIntervalScheduleDetail'])

export const periodicTasksClockedScheduleMethods = mapActions(
  'management/periodicTasks/periodicTasksClockedSchedule', ['fetchPeriodicTasksClockedSchedule', 'createUpdatePeriodicTasksClockedSchedule',
  'deletePeriodicTasksClockedSchedule', 'fetchPeriodicTasksClockedScheduleDetail'])

export const periodicTasksCrontabScheduleMethods = mapActions(
  'management/periodicTasks/periodicTasksCrontabSchedule', ['fetchPeriodicTasksCrontabSchedule', 'createUpdatePeriodicTasksCrontabSchedule',
  'deletePeriodicTasksCrontabSchedule', 'fetchPeriodicTasksCrontabScheduleDetail'])
//MASTERS:
export const mastersActorTypesMethods = mapActions(
  'masters/actorTypes', ['fetchActorTypes', 'createActorTypes', 'fetchOptionsActorTypes',
  'updateActorTypes', 'deleteActorTypes'])
  export const mastersOperationTypesMethods = mapActions(
    'masters/operationTypes', ['fetchOperationTypes', 'createOperationTypes', 'fetchOptionsOperationTypes',
    'updateOperationTypes', 'deleteOperationTypes'])
export const mastersCitiesMethods = mapActions(
  'masters/cities', ['fetchCities', 'createCities', 'fetchOptionsCities',
  'updateCities', 'deleteCities'])
export const mastersDocumentTypesMethods = mapActions(
  'masters/documentTypes', ['fetchDocumentTypes', 'createDocumentTypes', 'fetchOptionsDocumentTypes',
  'updateDocumentTypes', 'deleteDocumentTypes'])
export const mastersUnitsMeasurementMethods = mapActions(
    'masters/unitsMeasurement', ['fetchUnitsMeasurement', 'createUnitsMeasurement', 'fetchOptionsUnitsMeasurement',
    'updateUnitsMeasurement', 'deleteUnitsMeasurement'])
export const mastersProductsMethods = mapActions(
  'masters/products', ['fetchProducts', 'createProducts', 'fetchOptionsProducts',
  'updateProducts', 'deleteProducts', 'fetchProductsPrice', 'createProductsPrice', 'fetchOptionsProductsPrice',
  'updateProductsPrice', 'deleteProductsPrice'])
export const mastersPaymentMethodsMethods = mapActions(
  'masters/paymentMethods', ['fetchPaymentMethods', 'createPaymentMethods', 'fetchOptionsPaymentMethods',
  'updatePaymentMethods', 'deletePaymentMethods'])

//LICENSES
export const licensesMethods = mapActions(
  'licenses/licenses', ['fetchLicenses', 'createLicenses', 'fetchOptionsLicenses',
  'updateLicenses', 'deleteLicenses'])
//ACTORS
export const actorsMethods = mapActions(
  'actors/actors', ['fetchActors', 'createActors', 'fetchOptionsActors',
  'updateActors', 'deleteActors', 'fetchActorsGroup', 'createActorsGroup', 'fetchOptionsActorsGroup',
  'updateActorsGroup', 'deleteActorsGroup', 'fetchPlates', 'createPlates', 'updatePlates', 'deletePlates',
   'fetchOptionsPlates', 'fetchOptionsPlatesId', 'fetchPriceGroup', 'updatePriceGroup','createPriceGroup', 'fetchOptionsPrices'])
//STATIONS
export const stationsMethods = mapActions(
  'stations/stations', ['fetchStations', 'createStations', 'fetchOptionsStations',
  'updateStations', 'deleteStations'])
//INVENTORIES
export const inventoriesMethods = mapActions(
  'inventories/inventories', ['fetchInventories', 'createInventories', 'fetchOptionsInventories',
  'updateInventories', 'deleteInventories', 'fetchInventoriesTransfer', 'fetchInventoriesEntry',
  'fetchInventoriesSale', 'fetchReportPaymentEntry', 'fetchReportPaymentSale', 'fetchReportPaymentConsolidate', 
  'fetchReportProductConsolidate', 'fetchReportProductEntry', 'fetchReportProductSale', 'fetchSalesExcel', 'getInventory'])
//SALES
export const salesMethods = mapActions(
  'sales/sales', ['fetchSales', 'createSales', 'fetchOptionsSales',
  'updateSales', 'deleteSales'])